/**
 * Check whether the provided error object represents an AbortError.
 * @param {unknown} err
 * @returns {boolean}
 */
export const isAbortError = (err: unknown): boolean =>
  typeof err === "object" &&
  err !== null &&
  "name" in err &&
  (err as { name: unknown }).name === "AbortError";

/**
 * Extract a human-readable message from an error-like value.
 * Falls back to provided fallback string when no message can be determined.
 * @param {unknown} err
 * @param {string} fallback
 * @returns {string}
 */
export const getErrorMessage = (err: unknown, fallback: string): string =>
  err instanceof Error
    ? err.message
    : typeof err === "object" &&
        err !== null &&
        "message" in err &&
        typeof (err as { message: unknown }).message === "string"
      ? (err as { message: string }).message
      : fallback;
